import React, { useEffect, useState } from 'react'
import { ThirdwebSDK, ClaimCondition } from '@thirdweb-dev/sdk'
import {
  Ethereum,
  Polygon,
  Binance,
  Optimism,
  Arbitrum,
  Goerli,
  Sepolia,
  Mumbai,
  BinanceTestnet
} from '@thirdweb-dev/chains'
import { useSwitchChain, useChain, useChainId ,useConnectionStatus } from '@thirdweb-dev/react'
import { BigNumber, ethers } from 'ethers'
import { useAccount, useSwitchNetwork } from 'wagmi'
import { useEthersSigner } from 'utils/ethers'

interface Props {
  contractAddress: string
  chain:
    | 'ethereum'
    | 'polygon'
    | 'binance'
    | 'optimism'
    | 'arbitrum'
    | 'goerli'
    | 'sepolia'
    | 'mumbai'
    | 'bsc-testnet'
}

const MintComponent: React.FC<Props> = ({ contractAddress, chain }) => {
  //const switchChain = useSwitchChain()
  const { chains:wagmiChains, error, isLoading:isWagmiLoading, pendingChainId, switchNetwork } =
    useSwitchNetwork()
  const _chain = useChain()
  const chainId = useChainId();
  //const { chain, switchCurrentChain } = useContext(ChainContext)
  const [claimedTokens, setClaimedTokens] = useState<BigNumber | null>(null)
  const [totalSupply, setTotalSupply] = useState<BigNumber | null>(null)
  const [quantity, setQuantity] = useState<number>(1)
  const [activePhase, setActivePhase] = useState<ClaimCondition>()
  const { address } = useAccount()
  const signer = useEthersSigner()

  const [sdk, setSDK] = useState<ThirdwebSDK>()

  const [unclaimedTokens, setUnclaimedTokens] = useState<BigNumber | null>(null)
  const chains = {
    ethereum: Ethereum,
    polygon: Polygon,
    binance: Binance,
    optimism: Optimism,
    arbitrum: Arbitrum,
    goerli: Goerli,
    sepolia: Sepolia,
    mumbai:Mumbai,
    "bsc-testnet":BinanceTestnet
  }

  useEffect(() => {
    const fetchClaimedAndTotal = async () => {
      const sdkInstance = new ThirdwebSDK(chains[chain])
      setSDK(sdkInstance)
      console.log(chainId)
      console.log("SDK Set")
      console.log(chains[chain])
      const contract = await sdkInstance.getContract(contractAddress)
      //const nftDrop = new NFTDrop(sdk, contractAddress);
      try {
        const currentPhase = await contract.erc721.claimConditions.getActive()
        //console.log(currentPhase)
        //console.log(Number(currentPhase.price))
        setActivePhase(currentPhase)
        const claimed = await contract.erc721.totalClaimedSupply()
        const total = await contract.erc721.totalCount()
        setClaimedTokens(claimed)
        setTotalSupply(total)
      } catch (error) {
        console.error('Error fetching claimed and total:', error)
      }
    }

    fetchClaimedAndTotal()
  }, [chain, contractAddress])
  useEffect(() => {
    if (signer) {
      const temp = ThirdwebSDK.fromSigner(signer)
      setSDK(temp)
    }
  }, [signer])

  const handleIncrease = () => {
    const unclaimedTokensNumber = totalSupply
      ? totalSupply.sub(claimedTokens!)
      : 0
    if (quantity < Number(unclaimedTokensNumber)) {
      setQuantity(quantity + 1)
    }
  }

  const handleDecrease = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1)
    }
  }
  const call = async () => {
    try {
      if (!sdk) {
        //errorToast("Error: Wallet not connected");
        return
      }
      
      const totalCost = ethers.utils.formatUnits(
        activePhase!.price ?? 0,
        'ether'
      )
      const totalPrice = quantity * Number(totalCost)
      const totalCostInWei = ethers.utils.parseUnits(
        totalPrice.toString(),
        'ether'
      )
      const emptyAllowlistProof = {
        proof: [],
        quantityLimitPerWallet: 0,
        pricePerToken: activePhase!.price,
        currency: activePhase!.currencyAddress,
      }
      const emptyData = '0x'
      //sdk.updateSignerOrProvider(signer!);
      const contractjs = await sdk.getContract(contractAddress!)
      const data = await contractjs.call(
        'claim',
        [
          address,
          quantity,
          activePhase!.currencyAddress,
          activePhase!.price,
          emptyAllowlistProof,
          emptyData,
        ],
        { value: totalCostInWei }
      )
      //console.info("contract call success", data);
      //successToast("Claimed successfully");
    } catch (err) {
      console.error('contract call failure', err)
      //errorToast("Claim failed");
    }
  }
  return (
    <div className="flex flex-col justify-center text-center border-2 border-accent rounded-xl p-4">
      <h2 className="text-lg font-bold mb-2">
        {chain.charAt(0).toUpperCase() + chain.slice(1)}
        <br />
        {claimedTokens !== null && totalSupply !== null
          ? `${claimedTokens.sub(1).toString()}/${totalSupply.sub(1).toString()} NFTs Minted`
          : 'Loading...'}
      </h2>
      <div className="flex items-center mb-4 mx-auto">
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-l"
          onClick={handleDecrease}
          disabled={quantity <= 1}
        >
          -
        </button>
        <input
          type="number"
          min="1"
          max={totalSupply ? Number(totalSupply.sub(claimedTokens!)) : 1}
          value={quantity}
          onChange={(e) => {
            const unclaimedTokensNumber = totalSupply
              ? totalSupply.sub(claimedTokens!)
              : 0
            setUnclaimedTokens(unclaimedTokens)
            setQuantity(
              Math.min(Number(e.target.value), Number(unclaimedTokensNumber))
            )
          }}
          className="text-center w-20 dark:bg-jacarta-base dark:text-white"
        />
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-r"
          onClick={handleIncrease}
          disabled={
            quantity >=
            (totalSupply ? Number(totalSupply.sub(claimedTokens!)) : 1)
          }
        >
          +
        </button>
      </div>
      {_chain ? (
        _chain.chainId !== chains[chain].chainId ? (
          <button onClick={() => switchNetwork?.(chains[chain].chainId)} className="bg-green hover:bg-greenhover text-white font-bold py-3 px-4 rounded-xl">
            {pendingChainId === chains[chain].chainId ? 'Switching...' : 'Switch Network'}
          </button>
        ) : totalSupply && Number(totalSupply.sub(claimedTokens!)) > 0 ? (
          <button
            onClick={call}
            className="bg-green hover:bg-greenhover text-white font-bold py-3 px-4 rounded-xl"
          >
            Mint (
            {activePhase?.price && quantity
              ? parseFloat(ethers.utils.formatEther(activePhase.price)) *
                quantity
              : 'Loading...'}{' '}
            ETH)
          </button>
        ) : (
          <button
            className="bg-gray-500 text-white font-bold py-3 px-4 rounded-xl"
            disabled
          >
            Max Minted
          </button>
        )
      ) : null}
    </div>
  )
}

export default MintComponent
